import NotFound from '../components/modules/error/404';

const pageNotFound = [
  {
    path: '/page-not-found',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'Page not found',
      filter: false,
    },
  },
];

export default pageNotFound;
